import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appActionsHeaderAdditionalFilters]',
})
export class ActionsHeaderAdditionalFiltersDirective {
  public readonly templateRef = inject(TemplateRef<unknown>);
}
